import React, { useState, useEffect } from "react";
import {
  crearValvula,
  modificarValvula,
  desactivarValvula,
} from "../../services/ValvulaService";
import { obtenerEstructuraCompleta } from "../../services/api";
import { Edit2, Trash2 } from "lucide-react";

export default function MantenedorValvula() {
  const [valvulas, setValvulas] = useState([]);
  const [sectores, setSectores] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [valvulaForm, setValvulaForm] = useState({
    valvulaId: 0,
    sectorId: 0,
    codigo: "",
    descripcion: "",
    estadoId: 1,
    hash: "-",
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const estructura = await obtenerEstructuraCompleta();
      if (estructura?.estado && estructura.datos.length) {
        const camposApi = estructura.datos[0].campos || [];
        const sectoresApi = camposApi.flatMap(campo =>
          campo.modulos.flatMap(modulo =>
            modulo.sectores.map(sec => ({
              ...sec,
              moduloNombre: modulo.moduloNombre,
              campoNombre: campo.campoNombre,
            }))
          )
        );
        setSectores(sectoresApi);

        const valvulasApi = sectoresApi.flatMap(sec =>
          sec.valvulas.map(val => ({
            ...val,
            sectorNombre: sec.sectorNombre,
            moduloNombre: sec.moduloNombre,
            campoNombre: sec.campoNombre,
          }))
        );
        setValvulas(valvulasApi);
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  const abrirNuevo = () => {
    setValvulaForm({
      valvulaId: 0,
      sectorId: sectores[0]?.sectorId || 0,
      codigo: "",
      descripcion: "",
      estadoId: 1,
      hash: "",
    });
    setEditando(false);
    setMostrarModal(true);
  };

  const abrirEditar = valvula => {
    setValvulaForm({
      valvulaId: valvula.valvulaId,
      sectorId: valvula.sectorId,
      codigo: valvula.codigo,
      descripcion: valvula.descripcion,
      estadoId: valvula.estado,
      hash: valvula.codigoUnicoHash || "",
    });
    setEditando(true);
    setMostrarModal(true);
  };

  const guardar = async () => {
    try {
      const payload = { ...valvulaForm };
      if (editando) await modificarValvula(payload);
      else await crearValvula(payload);
      await cargarDatos();
      setMostrarModal(false);
    } catch (error) {
      console.error("Error al guardar válvula:", error);
    }
  };

  const desactivarRegistro = async (valvula) => {
    if (!window.confirm(`¿Eliminar válvula "${valvula.descripcion}"?`)) return;
    try {
      // enviar el objeto completo requerido por la API
      const valvulaCompleta = {
        valvulaId: valvula.valvulaId,
        sectorId: valvula.sectorId,
        codigo: valvula.codigo,
        descripcion: valvula.descripcion,
        estadoId: 2, // inactivo
        hash: "",
      };
      await desactivarValvula(valvulaCompleta);
      alert("✅ Válvula Eliminada correctamente.");
      cargarDatos();
    } catch (error) {
      alert(`❌ Error al eliminar válvula: ${error.message}`);
    }
  };



  return (
    <div className="p-6 bg-white rounded-md shadow-md font-sans">
      <header className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Mantenedor de Válvulas</h1>
        <button
          onClick={abrirNuevo}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
        >
          + Nueva Válvula
        </button>
      </header>

      <div className="overflow-x-auto border border-gray-200 rounded-md shadow-md">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {['ID', 'Código', 'Descripción', 'Sector', 'Estado', 'Acciones'].map(col => (
                <th
                  key={col}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {valvulas.map(v => (
              <tr key={v.valvulaId} className="odd:bg-white even:bg-gray-50 hover:bg-gray-100 transition">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{v.valvulaId}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{v.codigo}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{v.descripcion}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{v.sectorNombre}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    className={
                      v.estado === 1
                        ? 'inline-block px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800'
                        : 'inline-block px-3 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800'
                    }
                  >
                    {v.estado === 1 ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap flex space-x-2">
                  <button
                    onClick={() => abrirEditar(v)}
                    className="flex items-center px-3 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition"
                  >
                    <Edit2 size={16} className="mr-1" /> Editar
                  </button>
                  <button
                    onClick={() => desactivarRegistro(v)}
                    className="flex items-center px-3 py-1 border border-red-600 text-red-600 rounded-md hover:bg-red-50 transition"
                  >
                    <Trash2 size={16} className="mr-1" /> Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {mostrarModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg p-6 font-sans">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {editando ? 'Editar Válvula' : 'Nueva Válvula'}
            </h2>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sector destino</label>
                <select
                  value={valvulaForm.sectorId}
                  onChange={e => setValvulaForm({ ...valvulaForm, sectorId: parseInt(e.target.value, 10) })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                >
                  {sectores.map(sec => (
                    <option key={sec.sectorId} value={sec.sectorId}>
                      {sec.campoNombre} - {sec.moduloNombre} - {sec.sectorNombre}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Código</label>
                <input
                  type="text"
                  value={valvulaForm.codigo}
                  onChange={e => setValvulaForm({ ...valvulaForm, codigo: e.target.value })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                <input
                  type="text"
                  value={valvulaForm.descripcion}
                  onChange={e => setValvulaForm({ ...valvulaForm, descripcion: e.target.value })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Hash</label>
                <input
                  type="text"
                  value={valvulaForm.hash}
                  onChange={e => setValvulaForm({ ...valvulaForm, hash: e.target.value })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                <select
                  value={valvulaForm.estadoId}
                  onChange={e => setValvulaForm({ ...valvulaForm, estadoId: parseInt(e.target.value, 10) })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                >
                  <option value={1}>Activo</option>
                  <option value={2}>Inactivo</option>
                </select>
              </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
              <button
                onClick={() => setMostrarModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 transition"
              >
                Cancelar
              </button>
              <button
                onClick={guardar}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
